import { Button } from '@factorialco/deprecated-design-system'
import { TransfersDataTableDocument } from 'generated/resources/datatable.graphql'
import { BulkDeleteTransfersDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  transfersIds: number[]
  onClose: () => void
}

export const ConfirmDeleteTransfersModal = ({ transfersIds, onClose }: Props) => {
  const [bulkDeleteTransfers, { loading: loadingBulkDeleteTransfers }] = useMutation(
    BulkDeleteTransfersDocument,
    {
      extractorFn: (data) => data.bankingMutations.bulkDeleteBankingTransfer,
      refetchQueries: [TransfersDataTableDocument],
      awaitRefetchQueries: true,
    }
  )

  const handleSubmit = async () => {
    const result = await bulkDeleteTransfers({ variables: { ids: transfersIds } })
    const handled = handleResult(result, (errors) => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_error'),
        time: 3000,
      })
    })
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('banking.transfers.delete_transfers_modal.actions.delete_success'),
        time: 3000,
      })
      onClose()
    }
  }

  return (
    <Modal
      illustration={'delete'}
      title={i18n.tp('banking.transfers.delete_transfers_modal.title', {
        count: transfersIds.length,
      })}
      description={i18n.tp('banking.transfers.delete_transfers_modal.description', {
        count: transfersIds.length,
      })}
      onClose={onClose}
      onSubmit={handleSubmit}
      footer={
        <>
          <Button onClick={onClose} type="secondary" disabled={loadingBulkDeleteTransfers}>
            {i18n.t('banking.transfers.delete_transfers_modal.actions.cancel')}
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={loadingBulkDeleteTransfers}
            {...(loadingBulkDeleteTransfers && { iconName: 'circle' })}
          >
            {i18n.t('banking.transfers.delete_transfers_modal.actions.delete')}
          </Button>
        </>
      }
    />
  )
}
